/**
 *
 * @module widevineCertificateStorage
 *
 */

import Services from './../services/entry';
import CertificateStorage from './certificateStorage';

const DrmType = Services.Media.DrmType;

/**
 *
 * @class WidevineCertificateStorage
 * @extends {CertificateStorage}
 * @desc Provides a storage mechanism for storing a Widevine Certificate.
 * @since 3.2.0
 *
 */
export default class WidevineCertificateStorage extends CertificateStorage {

    /**
     *
     * @param {Sring} clientId
     * @param {String} environment
     * @param {SDK.Services.Storage} storage
     * @param {SDK.Logging.Logger} logger
     *
     */
    constructor(clientId, environment, storage, logger) {

        super(DrmType.WIDEVINE, clientId, environment, storage, logger);

        this.logger.log(WidevineCertificateStorage.name, 'Created.');

    }

}



// WEBPACK FOOTER //
// ./src/drm/widevineCertificateStorage.js